import React from "react";
import CustomDrawer from "@/shared/components/ui/Drawer/CustomDrawer";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import Accordion from "@/shared/components/Accordion";
import { ContactFilterFields, DEFAULT_FILTERS } from "@/shared/utils/utils";

const ContactFiltersUI = ({
  showfilters,
  setShowfilters,
  filters,
  setFilters,
  onUpdate,
  appliedFilters,
  clearFilters,
  zIndex = 100005,
}) => {
  return (
    <CustomDrawer
      isOpen={showfilters}
      onClose={() => setShowfilters(false)}
      direction={"right"}
      width={"370px"}
      height={"100%"}
      drawerClassName="rounded-tl-2xl will-change-transform"
      backdropClassName="z-[100005]"
      zIndex={zIndex}
      transitionDuration={400}
    >
      <div className="flex flex-col">
        {/* header */}
        <div className="flex items-center justify-between gap-1 border-b border-gray-200 dark:border-gray-800 p-3">
          <h6 className="text-sm font-semibold text-gray-800 dark:text-gray-100">
            Company Filters
          </h6>
          <div className="flex gap-2">
            {Object.keys(appliedFilters).length > 0 && (
              <SecondaryButton
                title={"Clear Filters"}
                textColor="light"
                onClick={clearFilters}
                className="shadow-none text-error-500 border-error-500"
              />
            )}
            <SecondaryButton
              title={"Apply"}
              textColor="light"
              onClick={onUpdate}
              disabled={
                JSON.stringify(filters) === JSON.stringify(DEFAULT_FILTERS)
              }
              className="shadow-none"
            />
          </div>
        </div>
        <div className="overflow-y-auto h-[calc(100dvh-65px)]">
          <Accordion
            filterFields={ContactFilterFields}
            filters={filters}
            setFilters={setFilters}
          />
        </div>
      </div>
    </CustomDrawer>
  );
};

export default ContactFiltersUI;
